<template>
  <div class="bee-select-wrapper">
    <div
      ref="reference"
      class="bee-select"
    >
      <slot name="input">
        <input type="hidden" :name="name" :value="currentValue"/>
      </slot>
    </div>
  </div>
</template>

<script>
import {oneOf} from '../../utils/assist'

export default {
  name: 'BeeSelect',
  props: {
    value: {
      type: [String, Number, Array],
      default: ''
    },
    name: String,
    autocomplete: { // 搜索建议
      validator: (value) => {
        return oneOf(value, ['on', 'off'])
      },
      default: 'off'
    }
  },
  data() {
    return {

    }
  },
  computed: {
    currentValue() {
      return ''
    }
  },
  components: {

  },
  watch: {

  },
  methods: {

  },
  created() {

  },
  mounted() {

  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/select/select.vue